import { FlexBox } from 'shared/components/Base/Base'
import { Text } from 'shared/components/Text/Text'
import { formatDate } from 'shared/helpers/formatters'
import { usePerformanceEvents } from 'shared/hooks/query/usePerformanceEvents'
import { primaryBlack, royalBlue } from 'shared/theme/colors'

import { PerformanceEventsList } from './PerformanceEventsList'

interface SafetyToolUserOnTimeRateProps {
  userId: string
}

export function SafetyToolUserOnTimeRate({ userId }: SafetyToolUserOnTimeRateProps) {
  const { performanceEvents } = usePerformanceEvents(userId, 'On Time Performance', { enabled: true })

  return (
    <FlexBox isColumn gap="16px">
      <Text variant="header3" fontColor={primaryBlack} mb={1}>
        Jobs with late stops
      </Text>

      <FlexBox>
        <PerformanceEventsList
          defaultOrderBy="jobDate"
          rows={performanceEvents ?? []}
          columns={[
            {
              field: 'jobHumanId',
              headerName: 'Job ID',
              width: 140,
              fontVariant: 'uppercaseLabel2',
              fontColor: royalBlue,
            },
            {
              field: 'jobDate',
              headerName: 'Date',
              width: 140,
              formatter: (e) => formatDate(e.jobDate),
              fontVariant: 'label2',
              fontColor: primaryBlack,
            },
            {
              field: 'originCityState',
              headerName: 'Origin → Destination',
              width: 340,
              formatter: (e) => e.originCityState + ' → ' + e.destinationCityState,
              fontVariant: 'header3',
              fontColor: primaryBlack,
            },
            {
              field: 'numStops',
              headerName: 'Stops',
              width: 80,
              fontVariant: 'header3',
              fontColor: primaryBlack,
            },
            {
              field: 'status',
              headerName: 'Status',
              formatter: (e) => (
                <Text variant="header3" fontColor={e.statusColor}>
                  {e.status}
                </Text>
              ),
              width: 160,
              fontVariant: 'header3',
              fontColor: primaryBlack,
            },
          ]}
        />
      </FlexBox>
    </FlexBox>
  )
}
